// axios
import axios from 'axios'
import { BASE_URL } from './urls.js'
//const baseURL = 'http://test.tacna.net:4444' //DEV Fausto
//const baseURL = 'http://dev.tacna.net:1212/internal_api/' //DEV JUAN
//const baseURL = 'https://portal.tacna.net/internal_api/' //PROD
//const baseURL = 'https://test.tacna.net/internal_api/' //Test
//const baseURL = 'http://dev.tacna.net:1213/' //DEV Carlos

const baseURL = `${BASE_URL  }internal_api/`

export default axios.create({
  baseURL,
  headers:{'Authorization': `Bearer ${localStorage.accessToken}`}
  // You can add your headers her
})
